import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import ModalDialog, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { PfLink } from '../PfLink';
import { ErrorSection } from './ErrorSection';
import { IntlNoticeMessages, NoticeMessage } from './NoticeMessages.intl';
import { ModalTitleContainer } from './styled';
export const NoticeDialog = ({
  title,
  titleVars,
  message,
  messageVars,
  confirmText,
  confirmLink,
  handleClose,
  isErrorNotice,
  errorDetails,
  isWarningNotice,
  overrideZIndex
}) => {
  const appearance = isErrorNotice ? 'danger' : isWarningNotice ? 'warning' : undefined;
  const actions = [];
  if (isErrorNotice) {
    // No unconfirmed close button.
  } else if (confirmLink) {
    actions.push({
      text: /*#__PURE__*/React.createElement(FormattedMessage, IntlNoticeMessages[NoticeMessage.Close]),
      onClick: () => handleClose(false),
      appearance: 'subtle'
    });
  } else {
    actions.push({
      text: /*#__PURE__*/React.createElement(FormattedMessage, IntlNoticeMessages[NoticeMessage.Cancel]),
      onClick: () => handleClose(false),
      appearance: 'subtle'
    });
  }
  const primaryButtonAppearance = appearance || 'primary';
  if (confirmLink) {
    actions.push({
      // @ts-ignore
      text: /*#__PURE__*/React.createElement(FormattedMessage, confirmText),
      href: confirmLink,
      target: '_blank',
      rel: 'noopener noreferrer',
      appearance: primaryButtonAppearance
    });
  } else {
    actions.push({
      // @ts-ignore
      text: /*#__PURE__*/React.createElement(FormattedMessage, confirmText),
      onClick: () => handleClose(true),
      appearance: primaryButtonAppearance
    });
  }
  let onOpenCompleteF;
  if (overrideZIndex) {
    onOpenCompleteF = (node, isAppearing) => {
      overrideZIndex && node.parentElement ? node.parentElement.style.zIndex = '5000' : undefined;
    };
  }
  return /*#__PURE__*/React.createElement(ModalDialog, {
    onOpenComplete: onOpenCompleteF,
    onClose: () => handleClose(),
    shouldCloseOnOverlayClick: false
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitleContainer, null, /*#__PURE__*/React.createElement(ModalTitle, {
    appearance: appearance
  },
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(FormattedMessage, _extends({}, title, {
    values: titleVars
  }))))), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("div", null,
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(FormattedMessage, _extends({}, message, {
    values: messageVars
  }))), isErrorNotice && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(FormattedMessage, IntlNoticeMessages[NoticeMessage.ErrorExplanations1]), ' ', /*#__PURE__*/React.createElement(PfLink, {
    href: "http://links.thinktilt.net/error-explanations"
  }, /*#__PURE__*/React.createElement(FormattedMessage, IntlNoticeMessages[NoticeMessage.ErrorExplanations2])), ' ', /*#__PURE__*/React.createElement(FormattedMessage, IntlNoticeMessages[NoticeMessage.ErrorExplanations3]), ' ', /*#__PURE__*/React.createElement(PfLink, {
    href: "https://support.thinktilt.com/"
  }, /*#__PURE__*/React.createElement(FormattedMessage, IntlNoticeMessages[NoticeMessage.ErrorExplanations4])), "."), !!errorDetails && /*#__PURE__*/React.createElement(ErrorSection, {
    errorDetails: errorDetails
  })), /*#__PURE__*/React.createElement(ModalFooter, null, actions.map(({
    text,
    ...props
  }) => /*#__PURE__*/React.createElement(Button, props, text))));
};